/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_ConcurrentInputs */

const en_mk_mx_concurrent = /** @type {(inputs: Mk_Mx_ConcurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks running at once`)
};

const id_mk_mx_concurrent = /** @type {(inputs: Mk_Mx_ConcurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas berjalan bersamaan`)
};

/**
* | output |
* | --- |
* | "Tasks running at once" |
*
* @param {Mk_Mx_ConcurrentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_concurrent = /** @type {((inputs?: Mk_Mx_ConcurrentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_ConcurrentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_concurrent(inputs)
	return en_mk_mx_concurrent(inputs)
});